// TO BE REMOVED

export const SEND_WELCOME_EMAIL = "SEND_WELCOME_EMAIL";
export const SEND_WORKBOOK_EMAIL = "SEND_WORKBOOK_EMAIL";
export const RESET_ALL_MESSAGES = "RESET_ALL_MESSAGES";

export const SET_PAGINATION = "SET_PAGINATION";

export interface ISetPagination {
  type: typeof SET_PAGINATION;
  payload: Partial<Pagination>;
  paginationType: PaginationType;
  reset?: boolean;
}

export const RESET_PAGINATION = "RESET_PAGINATION";

export interface IResetPagination {
  type: typeof RESET_PAGINATION;
  paginationType: PaginationType;
}

/* ==== TESTS TEMPLATES */
export const HANDLE_FETCH_ALL_TESTS_TEMPLATES = "HANDLE_FETCH_ALL_TESTS_TEMPLATES";

export interface IHandleFetchAllTestsTemplates {
  type: typeof HANDLE_FETCH_ALL_TESTS_TEMPLATES;
}

export const SET_TESTS_TEMPLATES = "SET_TESTS_TEMPLATES";

export interface ISetTestsTemplates {
  type: typeof SET_TESTS_TEMPLATES;
  payload: TestTemplate[];
}

/* ==== LESSONS TEMPLATES */
export const HANDLE_FETCH_LESSONS_TEMPLATES = "HANDLE_FETCH_LESSONS_TEMPLATES";

export interface IHandleFetchLessonsTemplates {
  type: typeof HANDLE_FETCH_LESSONS_TEMPLATES;
}

export const SET_LESSONS_TEMPLATES = "SET_LESSONS_TEMPLATES";

export interface ISetLessonsTemplates {
  type: typeof SET_LESSONS_TEMPLATES;
  payload: LessonTemplate[];
}

/* ==== WORKSHEETS TEMPLATES */
export const HANDLE_FETCH_WORKSHEETS_TEMPLATES = "HANDLE_FETCH_WORKSHEETS_TEMPLATES";

export interface IHandleFetchWorksheetsTemplates {
  type: typeof HANDLE_FETCH_WORKSHEETS_TEMPLATES;
}

export const SET_WORKSHEETS_TEMPLATES = "SET_WORKSHEETS_TEMPLATES";

export interface ISetWorksheetsTemplates {
  type: typeof SET_WORKSHEETS_TEMPLATES;
  payload: WorksheetTemplate[];
}

export const SET_GLOBAL_TEMPLATE_LOADER = "SET_GLOBAL_TEMPLATE_LOADER";

export interface ISetGlobalTemplateLoader {
  type: typeof SET_GLOBAL_TEMPLATE_LOADER;
  payload: boolean;
}

export const HANDLE_FETCH_WORKSHEETS_FILTER_ITEMS = "HANDLE_FETCH_WORKSHEETS_FILTER_ITEMS";

export interface IHandleFetchWorksheetsFilterItems {
  type: typeof HANDLE_FETCH_WORKSHEETS_FILTER_ITEMS;
}

export const SET_WORKSHEETS_FILTER_ITEMS = "SET_WORKSHEETS_FILTER_ITEMS";

export interface ISetWorksheetsFilterItems {
  type: typeof SET_WORKSHEETS_FILTER_ITEMS;
  payload: FilterOption[];
}

export const HANDLE_FETCH_LESSONS_FILTER_ITEMS = "HANDLE_FETCH_LESSONS_FILTER_ITEMS";

export interface IHandleFetchLessonsFilterItems {
  type: typeof HANDLE_FETCH_LESSONS_FILTER_ITEMS;
}

export const SET_LESSONS_FILTER_ITEMS = "SET_LESSONS_FILTER_ITEMS";

export interface ISetLessonsFilterItems {
  type: typeof SET_LESSONS_FILTER_ITEMS;
  payload: FilterOption[];
}

// export const SET_DETAILS_MODAL_DATA = "SET_DETAILS_MODAL_DATA";

// export interface ISetDetailsModalData {
//   type: typeof SET_DETAILS_MODAL_DATA;
//   payload: any;
// }

export const SET_ERROR_SIGNAL = "SET_ERROR_SIGNAL";

export interface ISetErrorSignal {
  type: typeof SET_ERROR_SIGNAL;
  payload: boolean;
}

export const HANDLE_FETCH_SUBJECTS = "HANDLE_FETCH_SUBJECTS";

export interface IHandleFetchSubjects {
  type: typeof HANDLE_FETCH_SUBJECTS;
}

export const SET_SUBJECTS = "SET_SUBJECTS";

export interface ISetSubjects {
  type: typeof SET_SUBJECTS;
  payload: Subject[];
}

/* Spinners for whole application */
export const SET_ACTION_SPINNER = "SET_ACTION_SPINNER";

export interface ISetActionSpinner {
  type: typeof SET_ACTION_SPINNER;
  payload: boolean;
}

export const SET_GLOBAL_SPINNER = "SET_GLOBAL_SPINNER";

export interface ISetGlobalSpinner {
  type: typeof SET_GLOBAL_SPINNER;
  payload: boolean;
}

export const SET_FETCH_DETAILS_SPINNER = "SET_FETCH_DETAILS_SPINNER";

export interface ISetFetchDetailsSpinner {
  type: typeof SET_FETCH_DETAILS_SPINNER;
  payload: boolean;
}

export const SET_FETCH_SPINNER = "SET_FETCH_SPINNER";

export interface ISetFetchSpinner {
  type: typeof SET_FETCH_SPINNER;
  payload: boolean;
}

export const SET_FETCH_CALENDAR_SPINNER = "SET_FETCH_CALENDAR_SPINNER";

export interface ISetFetchCalendarSpinner {
  type: typeof SET_FETCH_CALENDAR_SPINNER;
  payload: boolean;
}

export const SET_FETCH_SUBLIST_SPINNER = "SET_FETCH_SUBLIST_SPINNER";

export interface ISetFetchSublistSpinner {
  type: typeof SET_FETCH_SUBLIST_SPINNER;
  payload: boolean;
}

/* End of spinners for whole application */

export const HANDLE_FETCH_LESSON_TEMPLATE_DETAILS = "HANDLE_FETCH_LESSON_TEMPLATE_DETAILS";

export interface IHandleFetchLessonTemplateDetails {
  type: typeof HANDLE_FETCH_LESSON_TEMPLATE_DETAILS;
  payload: string;
}

export const HANDLE_FETCH_WORKSHEET_TEMPLATE_DETAILS = "HANDLE_FETCH_WORKSHEET_TEMPLATE_DETAILS";

export interface IHandleFetchWorksheetTemplateDetails {
  type: typeof HANDLE_FETCH_WORKSHEET_TEMPLATE_DETAILS;
  payload: string;
}

export const HANDLE_FETCH_TEST_TEMPLATE_DETAILS = "HANDLE_FETCH_TEST_TEMPLATE_DETAILS";

export interface IHandleFetchTestTemplateDetails {
  type: typeof HANDLE_FETCH_TEST_TEMPLATE_DETAILS;
  payload: string;
}

/* Hint lists actions */

export const HANDLE_FETCH_LESSONS_HINTS = "HANDLE_FETCH_LESSONS_HINTS";

export interface IHandleFetchLessonsHints {
  type: typeof HANDLE_FETCH_LESSONS_HINTS;
}

export const SET_LESSONS_HINTS = "SET_LESSONS_HINTS";

export interface ISetLessonsHints {
  type: typeof SET_LESSONS_HINTS;
  payload: Hint[];
}

export const HANDLE_FETCH_WORKSHEETS_HINTS = "HANDLE_FETCH_WORKSHEETS_HINTS";

export interface IHandleFetchWorksheetsHints {
  type: typeof HANDLE_FETCH_WORKSHEETS_HINTS;
}

export const SET_WORKSHEETS_HINTS = "SET_WORKSHEETS_HINTS";

export interface ISetWorksheetsHints {
  type: typeof SET_WORKSHEETS_HINTS;
  payload: Hint[];
}

export const HANDLE_FETCH_UNITS = "HANDLE_FETCH_UNITS";

export interface IHandleFetchUnits {
  type: typeof HANDLE_FETCH_UNITS;
}

export const SET_UNIT_FILTER_OPTIONS = "SET_UNIT_FILTER_OPTIONS";

export interface ISetUnitFilterOptions {
  type: typeof SET_UNIT_FILTER_OPTIONS;
  payload: SelectOption[];
}

export const HANDLE_FETCH_CLASSROOMS_SIMPLIFIED = "HANDLE_FETCH_CLASSROOMS_SIMPLIFIED";

export interface IHandleFetchClassroomsSimplified {
  type: typeof HANDLE_FETCH_CLASSROOMS_SIMPLIFIED;
  all?: boolean;
}

export const SET_CLASSROOMS_SIMPLIFIED = "SET_CLASSROOMS_SIMPLIFIED";

export interface ISetClassroomsSimplified {
  type: typeof SET_CLASSROOMS_SIMPLIFIED;
  payload: Partial<Classroom>[];
}

export const HANDLE_FETCH_INSTRUCTORS_SIMPLIFIED = "HANDLE_FETCH_INSTRUCTORS_SIMPLIFIED";

export interface IHandleFetchInstructorsSimplified {
  type: typeof HANDLE_FETCH_INSTRUCTORS_SIMPLIFIED;
  all?: boolean;
}

export const SET_INSTRUCTORS_SIMPLIFIED = "SET_INSTRUCTORS_SIMPLIFIED";

export interface ISetInstructorsSimplified {
  type: typeof SET_INSTRUCTORS_SIMPLIFIED;
  payload: Partial<Instructor>[];
}

export const HANDLE_FETCH_LOCATIONS_SIMPLIFIED = "HANDLE_FETCH_LOCATIONS_SIMPLIFIED";

export interface IHandleFetchLocationsSimplified {
  type: typeof HANDLE_FETCH_LOCATIONS_SIMPLIFIED;
  all?: boolean;
}

export const SET_LOCATIONS_SIMPLIFIED = "SET_LOCATIONS_SIMPLIFIED";

export interface ISetLocationsSimplified {
  type: typeof SET_LOCATIONS_SIMPLIFIED;
  payload: Partial<TLocation>[];
}

// -------
export const HANDLE_FETCH_STUDENTS_SIMPLIFIED = "HANDLE_FETCH_STUDENTS_SIMPLIFIED";

export interface IHandleFetchStudentsSimplified {
  type: typeof HANDLE_FETCH_STUDENTS_SIMPLIFIED;
  all?: boolean;
}

export const SET_STUDENTS_SIMPLIFIED = "SET_STUDENTS_SIMPLIFIED";

export interface ISetStudentsSimplified {
  type: typeof SET_STUDENTS_SIMPLIFIED;
  payload: Partial<Student>[];
}

export const HANDLE_FETCH_COURSES = "HANDLE_FETCH_COURSES";

export interface IHandleFetchCourses {
  type: typeof HANDLE_FETCH_COURSES;
}

export const SET_COURSES = "SET_COURSES";

export interface ISetCourses {
  type: typeof SET_COURSES;
  payload: Course[];
}

export const SET_ACTIVE_COURSE = "SET_ACTIVE_COURSE";

export interface ISetActiveCourse {
  type: typeof SET_ACTIVE_COURSE;
  payload: Course;
}

export const SET_LESSON_TEMPLATE_PREVIEW = "SET_LESSON_TEMPLATE_PREVIEW";

export interface ISetLessonTemplatePreview {
  type: typeof SET_LESSON_TEMPLATE_PREVIEW;
  payload: LessonTemplate;
}

export const SET_WORKSHEET_TEMPLATE_PREVIEW = "SET_WORKSHEET_TEMPLATE_PREVIEW";

export interface ISetWorksheetTemplatePreview {
  type: typeof SET_WORKSHEET_TEMPLATE_PREVIEW;
  payload: WorksheetTemplate;
}

export const SET_CATEGORY_TREE = "SET_CATEGORY_TREE";

export interface ISetCategoryTree {
  type: typeof SET_CATEGORY_TREE;
  payload: WorksheetCategory[];
}

export const SET_WORKSHEETS_BY_CATEGORY = "SET_WORKSHEETS_BY_CATEGORY";

export interface ISetWorksheetsByCategories {
  type: typeof SET_WORKSHEETS_BY_CATEGORY;
  payload: WorksheetTemplate[];
}

export const SET_REPORT_SPINNER = "SET_REPORT_SPINNER";

export interface ISetReportSpinner {
  type: typeof SET_REPORT_SPINNER;
  payload: boolean;
}
